import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "mode", "expiryGroup", "expiryInput", "hint" ]

  connect() {
    this.defaultExpiryValue = this.hasExpiryInputTarget ? this.expiryInputTarget.dataset.defaultValue : ""

    if (this.hasExpiryInputTarget && !this.expiryInputTarget.value && this.defaultExpiryValue) {
      this.expiryInputTarget.value = this.defaultExpiryValue
    }
    this.toggle()
  }

  toggle() {
    if (!this.hasModeTarget || !this.hasExpiryInputTarget) return

    const persistent = this.modeTarget.value === "persistent"
    this.expiryInputTarget.disabled = persistent
    this.expiryInputTarget.required = false

    if (this.hasExpiryGroupTarget) {
      this.expiryGroupTarget.classList.toggle("hidden", persistent)
    }
    if (!persistent && !this.expiryInputTarget.value && this.defaultExpiryValue) {
      this.expiryInputTarget.value = this.defaultExpiryValue
    }

    if (this.hasHintTarget) {
      this.hintTarget.textContent = persistent ? "Auto-expiry is disabled while share link validity is set to never expire." : "Default auto-expiry timing is preselected. You can adjust it if needed."
    }
  }
}
